import { useQuery } from 'react-query';
import * as ConnectedAccountApi from 'apis/connectedAccount';
import { AxiosError } from 'axios';

import { CONNECTED_ACCOUNT_STATUSES } from 'constants/stripe';

export type IConnectedAccount =
  ConnectedAccountApi.FetchConnectedAccountsResponse['data'][0];

const getConnectedAccounts = async ({
  status,
}: {
  status?: Array<CONNECTED_ACCOUNT_STATUSES>;
}) => {
  const { data: connected_accounts } =
    await ConnectedAccountApi.fetchConnectedAccounts({
      status,
    });

  return { connected_accounts };
};

const useQueryConnectedAccounts = ({
  status,
  enabled,
  onError,
}: {
  status?: Array<CONNECTED_ACCOUNT_STATUSES>;
  enabled: boolean;
  onError: (e: AxiosError) => void;
}) => {
  const {
    data,
    isLoading: is_loading,
    refetch,
  } = useQuery(
    ['getConnectedAccounts'],
    () => getConnectedAccounts({ status }),
    {
      enabled,
      onError,
    }
  );

  return {
    data,
    is_loading,
    refetch,
  };
};

export default useQueryConnectedAccounts;
